import {isDev} from "../functions";

export default 'https://sepolia.drpc.org'